/* eslint-disable */
/**
 * ReyDRLocalizations are specific to datbase columns and tables.
 * The exact structure replicated in each language supported.
 *
 * Explanation of structure by Example with comments:
 *   Central: {   //#1
 *       DMSBranch: DMSBranch, //#2
 *       DMSStore: DMSStore, //#3
 *       SpecializedLocaleTable: { //#4
 *           AlertTypeLocale: AlertTypeLocale,  //#5
 *       },
 *   },
 *
 * #1:  Central refers to the database.
 *
 * #2:  Pull translated column names for DMSBranch table columns.  For example. DMSBranch.DMSBranhId = 'Business Unit'
 *
 * #3:  Pull translated column names for DMSStore.  For Example: DMSStore.DMSStoreId = 'Group'
 *
 * #4:  SpecializedLocaleTables are the tables in the database that typically end in locale and store localizationed
 *      strings as its row data.
 *
 * #5:  Each AlertTypeId will reference an alerttypename.
 */


export const UILocalizationENUS = {
    NoItemsFoundFor: 'No items found for {0}',
    Back: 'Back',
    Profile: 'Profile',
    Vehicle: 'Vehicle',
    Calendar: 'Calendar',
    Menu: 'Menu',
    DealerLogo: 'Dealer Logo',
    Welcome: 'Welcome!',
    VisitedBefore: 'Have you visited us before?',
    Hello: 'Hello,',
    GetApptAdded: `Let's get your appointment added!`,
    WhatName: 'What is your name?',
    FirstName: 'First Name *',
    LastName: 'Last Name *',
    Proceed: 'Proceed',
    Email: 'Email Address',
    Password: 'Password *',
    CreateAcct: 'Create Account',
    Login: 'Login',
    HaveAccount: 'Have an account?',
    SignUp: 'Sign Up',
    FieldsCreateAcct: 'Please enter each field below to create your account.',
    ConfirmPassword: 'Confirm Password *',
    EmailLengthError: 'Email cannot be longer than 128 characters.',
    PasswordLengthError: 'Password cannot be longer than 10 characters.',
    PasswordMismatch: 'The entered passwords do not match.  Please re-enter',
    NameLengthError: '{0} cannot be longer than 35 characters',
    EmptyNameError: '{0} cannot be left blank.',
    WhatAreMaintenanceSchedules: 'What are Maintenance Schedules?',
    WhatAreMaintenanceSchedulesText1: 'These are pre-made packages that include all the maintenance services you need based on the current mileage and age of your vehicle.',
    WhatAreMaintenanceSchedulesText2: 'You do not need to add any individual services included in these packages and each fulfills your scheduled interval maintenance requirements.',
    PricingDisclaimer: '** Pricing displayed is based on information available and user selections on the site.  The final price in the dealership may be different than the final estimate this tool provides.',
    Item: 'item',
    Items: 'items',
    ScheduleOption: 'Choose a schedule option:',
    MileageOption: 'Schedule below is based on vehicle mileage of:',
    MenuScheduleDetails: 'Menu Schedule Details',
    WhyDoINeedThis: 'Why do I need this?',
    WhatIsThisFor: 'What is this for?',
    RecommendedVehicle: 'Recommended for your vehicle because:',
    ThisMaintenanceIncludes: 'This Maintenance includes',
    PhoneNumber: 'Phone Number *',
    EmailAddress: 'Email Address *',
    Start: 'Start',
    SchAppt: 'Schedule Appointment',
    YourAcct: 'Your Account',
    CheckRepair: 'Check on a Repair',
    LogIn: 'Log In',
    MoreDetails: 'More Details',
    ServicePortal: 'Service Portal',
    WeOwesHeader: 'We Owe You',
    WeOwesDescription: 'It looks like we owe you some work.  Select any you would like to add to your appointment.',
    RecallsHeader: 'Recalls',
    RecallsDescription: '{0} has published the following recalls on your vehicle.  Select a recall to let your service advisor know you\'re interested.  Additional appointments may be needed.',
    RecommendedHeader: 'Recommended',
    RecommendedDescription: 'We recommended the following services during your last visit.  Would you like to select any for your appointment?',
    WorkDoneElsewhere: 'You can also let us know if you\'ve already had the work done elsewhere.',
    SelectWeOwe: 'Select any you would like to add to your appointment.',
    DoneElsewhere: 'I had this work done elsewhere',
    Excellent: 'Excellent!',
    EnterPhoneEmail: 'Please enter your email or phone number to easily locate your vehicle to get started.',
    LoginPrompt: 'Already set up an account? You can log in here.',
    OrLiteral: 'OR',
    NoImNew: `No, I'm New`,
    YesIHave: 'Yes, I have',
    Cancel: 'Cancel',
    Update: 'Update',
    EnterEmailPassword: 'Enter your email and password below.',
    ForgotPassword: 'Forgot Password?',
    NoAccount: `Don't have an account?`,
    GladtoSee: 'Glad to see you!',
    HiUser: 'Hi {0},',
    AccountSelect: 'Select what you would like to do:',
    ApptRepair: 'Appointment / Repair',
    Account: 'Account',
    ContactUs: 'Contact Us',
    ViewCurrentRepair: 'View current repair(s)',
    ViewCurrentAppt: 'View / Change upcoming appointment(s)',
    AddNewAppt: 'Add new appointment',
    NewAppt: 'New Appointment',
    ViewAcctInfo: 'View / Update account information',
    ViewDocuments: 'View documents',
    ChangePassword: 'Change password',
    ViewVehicles: 'View / Edit vehicle(s)',
    CheckMfgRecalls: 'Check for manufacturer recalls on vehicle',
    ViewRecommended: 'View recommended service(s)',
    ViewRepairHist: 'View vehicle repair history',
    AddVehicle: 'Add Vehicle',
    ContactDealer: 'Contact the dealership',
    GladToHaveYou: `Glad to have you! Let's get you going quickly.`,
    WhichVehicle: 'What vehicle are you bringing in?',
    FirstVisit: 'First Visit?',
    SelectMake: 'Select Your Make',
    SelectModel: 'Select Model',
    SelectTrim: 'Select Trim',
    SelectYear: 'Select Year',
    DisplaySelVeh: 'Your selected vehicle will display here.',
    SelVehicle: 'Your selected vehicle:',
    Miles: 'miles',
    UnknownMileage: 'I do not know my mileage.',
    VehicleAddBtn: 'ADD VEHICLE',
    EstimatedMileage: 'Estimated Total Mileage *',
    AddServices: 'Select the services your vehicle needs as well as your appointment time',
    AddServiceBtnText: 'Add Services',
    AddIndSvcBtnText: 'ADD SERVICE',
    RemoveSvcBtnText: 'REMOVE SERVICE',
    SkipServices: 'Skip adding services and go to selecting your appointment time',
    SkipServiceBtnText: 'Skip Services',
    SkipServiceReason: 'Tell us why you\'re bringing your vehicle in for service:',
    QuickTimesAdv: 'Here was your advisor last visit and their next available appointment times:',
    QuickTimesTrans: 'Your transportation last visit was: ',
    QuickTimesTransDefault: 'Here are some appointment times with transportation: ',
    TransAltLit: `I'd like to use a {0} car`,
    ApptSelected: 'Appointment Time Selected!',
    ServiceAdded: 'Service Added!',
    WeFoundYou: 'Which vehicle are you servicing with us?',
    PreviousMileage: ` - Previous Mileage (as of {0})`,
    CurrentMileage: ' - Current Mileage',
    AddNewVehicle: 'Add New Vehicle',
    DateTime: 'Date & Time',
    Transportation: 'Transportation',
    EnterVin: 'Enter Your VIN',
    SelectColorMileage: 'Enter your Estimated Mileage.  ',
    VINunknown: 'I don\'t know my VIN.',
    Red: 'Red',
    White: 'White',
    SelectColor: 'Select Color *',
    VIN: 'Vehicle Identification Number (VIN)',
    Make: 'Make',
    Year: 'Year',
    Model: 'Model',
    Trim: 'Trim',
    EnterEstimatedMileage: 'Enter Estimated Mileage *',
    Skip: 'Skip',
    DiffColor: 'Different Color',
    EnterDiffColor: 'Enter Different Color *',
    AlmostThere: 'Almost There!',
    ReadyToAdd: 'We\'re ready to add your appointment, but first enter your name, phone, and email:',
    Advisor: 'Advisor',
    Write: 'Write',
    ManuallyWrite: 'Manually write out issue',
    AddedIssue: 'Added Issue',
    YourIssue: 'Your issue is:',
    AnyAdditional: 'Any additional comments?',
    WalkThroughDiagnose: 'Let\'s walk through diagnosing your issue',
    Diagnose: 'Diagnose',
    WalkThroughIssue: 'Let us walk you through your issue',
    PleaseDescribe: 'Please describe your issue',
    ConfirmIssue: 'Confirm Issue',
    AddIssueButton: 'Add Issue',
    AddDiagnosisButton: 'Add Diagnosis',
    DiagnoseButton: 'Diagnose Issue',
    CancelButton: 'Cancel',
    BackButton: 'Back',
    NextButton: 'Next',
    DiagnoseHeader: 'Diagnose',
    CallDealerForPricing: 'Call Dealer for Pricing',
    CustomRange: 'Custom Range',
    HereAre: 'Here are',
    Times: 'times for',
    With: 'with',
    ApptDay: 'Which day would you like your appointment on?',
    TimeFilter: 'Limit the times that display to a certain time of day or choose your own range.',
    AdvisorSelect: 'Would you like to see a certain advisor for your appointment?',
    DifferentTime: 'Different Time',
    YourAppt: 'Your Appointment:',
    ApptIn: 'Appointment in:',
    Close: 'Close',
    YourApptDate: 'Your Appointment Date',
    Congratulations: 'Congratulations!',
    ApptWasAdded: 'Your Appointment was added!',
    ApptWasUpdated: 'Your Appointment was updated!',
    CommConfirm: 'You will receive an email/text confirmation shortly.',
    SaveAppt: 'Save Appointment',
    CalendarAddLink: 'Click on a link to add appointment to your calendar:',
    Google: 'Google',
    Yahoo: 'Yahoo',
    Outlook: 'Outlook',
    CreateAcctOnConfirm: 'Would you like to create an account to manage and track your vehicle while in the shop as well as easily add future appointments?',
    NoThanks: 'No Thanks',
    EnterNewPassword: ', enter your new password below',
    Reset: 'Reset',
    ResetPass: 'Reset Password',
    OperationDetails: 'Operation Details',
    Selected: 'Selected: ',
    RetrievingDataFromOEM: 'Retrieving data from manufacturer...',
    RecommendedAlert: 'Required Immediate Attention',
    RecommendedWarning: 'Required Attention Soon',
    InvalidField: 'Invalid Field',
    InquiryError: 'We are unable to check your vehicle for recalls at this time.  Please contact the dealership to see if open recalls exist for your vehicle.',
    Date: 'Date',
    Time: 'Time: ',
    IncorrectPassword: 'Incorrect Password',
    IncorrectPassMsg: 'Sorry, the password for this account is incorrect.  Would you like to try again or email yourself a link to reset your password? (Password is case-sensitive.)',
    IncorrectCode: `Incorrect Code`,
	ExpiredCode: `Code Expired`,
	InvalidCode: `Invalid Code`,
	EnterCodeAgain: `The security code entered is incorrect. Please enter the code again or send a new code.`,
    SecurityCode: 'Security Code *',
	RequestNewCode: `The code you tried to enter has expired. Please request a new authentication code.`,
	RequestOrContact: `The code you tried to enter has expired. Please request a new authentication code.`,
    TryAgain: 'Try Again',
    NoAccountFound: 'No Account Found',
    NoAccFoundMsg: 'Sorry, we couldn\'t find an account tied to {0}. Would you like to try again or sign up a new account?',
    AddYourOwnIndService: 'Add your own service?',
    AddYourOwnIndServiceDetails: 'Don\'t see what you are looking for below?  You can add your own service by either using our diagnostic tool or manually writing it out.  Click the link below to go there now.',
    AddYourOwnIndServiceLink: 'Go to Write Your Own Services',
    Continue: 'Continue',
    // CustSearchErrorMessage: 'Sorry, we couldn\'t find your record using {0}. Do you want to change this information and try again or continue adding your appointment as a new customer?',
    CustSearchErrorMessage: 'We couldn\'t find you using {0}. Do you want to try again with a different phone number or email address or continue adding your appointment as a new customer?',
    CompanyAccFound: 'Sorry, we can\'t access vehicles for the record using {0} at this time. Please call {1} to make an appointment or continue adding your appointment as a new customer.',
    NoVehAccess: 'No Vehicle Access',
    RecommendedLastVisit: 'Recommended Last Visit',
    WhatAreRecalls: 'A recall is issued when a manufacturer or NHTSA determines that a vehicle, equipment, car seat or tire creates an unreasonable safety risk or fails to meet minimum safety standards.  Most decisions to conduct a recall and remedy a safety defect are made voluntarily by manufacturers prior to any involvement by NHTSA. - National Highway Traffic Safety Administration ',
    No: 'No',
    Yes: 'Yes',
    DetailsNotAvailable: 'Details are not available for this service.  Please contact the dealership for more information.',
    SelectYourVeh: 'Select Your Vehicle',
    AccessiblityPanel: 'Accessibility Control Panel',
    AccessiblityHeader: 'Select the following option to alter site appearance to better serve your needs:',
    ColorSensitive: 'Activate Color-Sensitive Appearance',
    UpdateSite: 'Update Site',
    RequiredFields: 'Required fields are marked with an asterisk "*"',
    SchApptTitle: 'Click to begin scheduling a service appointment',
    YourAcctTitle: 'Click to view your online owner account',
    CheckRepairTitle: 'Click to view the real-time status of your service repairs',
    MenuTitle: 'Click to access the site menu navigation',
    BackTitle: 'Click to return to the previous page',
    ProfileTitle: 'Click to view and update your information',
    LogInTitle: 'Click to log in to your online account',
    UpdateTitle: 'Click to save your changes',
    Services: 'Services',
    MinEstCost: 'Minimum Est Cost: $',
    ReadDisclaimer: 'I have read the full disclaimer',
    ContactEmail: 'Email',
    ContactTextMessage: 'Text',
    ContactBoth: 'Both',
    NoCapital: 'NO',
    YesCapital: 'YES',
    Confirmation: 'Confirmation',
    SendConfirmation: 'Send your appointment confirmation to: *',
    MakePreferred: 'Make this your preferred contact method?',
    TextOptIn: 'Text Message Opt In',
    OptIn1: 'Selecting “Yes” provides your express written consent to ',
    OptIn2: ' to send you automated text messages. You may withdraw your consent at any time by responding STOP to ',
    OptIn3: ` or by contacting `,
    OptIn4: ' at ',
    OptIn5: '. Not required for purchase. Standard message and data rates may apply.',
    OptIn6: 'Messaging Privacy Policy/Terms of Service.',
    Appointment: 'Appointment',
    ServiceAppt: '- Service Appointments',
    Dealership: 'Dealership',
    Photo: 'Photo',
    Image: 'Image',
    HereProfile: 'Here is what we have on file for you:',
    StreetAddress: 'Street Address *',
    City: 'City *',
    State: 'State *',
    ZipCode: 'ZIP Code *',
    OptedIn: 'Opted In',
    ChangeInfo: 'Change Information',
    LetsReviewAdd: 'Let\'s review your options one last time before we add your appointment.',
    LetsReviewModify: 'Let\'s review your options one last time before we modify the appointment:',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    ext: 'ext',
    PhoneHeader: 'Phone Number',
    EmailHeader: 'Email',
    AddressHeader: 'Address',
    Hours: 'Hours of Operation',
    AdditionalInfo: 'Additional Information',
    Service: 'Service',
    Express: 'Express',
    BdyShop: 'Body Shop',
    Contact: 'Contact',
    WhichDept: 'Which department would you like to contact?',
    AddApptMsg1: 'You currently are not scheduled for service. Want to add an appointment? Click the button below.',
    AddApptMsg2: 'You are currently scheduled for service. Want to add another appointment? Click the button below.',
    AddCustVehMsg: 'Please enter the VIN.',
    UpcomingAppt: 'Upcoming Appointment',
    EditAppt: 'Edit Appointment',
    In: 'in',
    PrevRecommSvc: 'These are services we recommended during your last visit.',
    SelPrevRecomm: 'Select any you would like to add to an appointment.',
    PrevRecomm: 'Previously Recommended',
    outStandingRcl: 'Outstanding Recalls',
    zeroNumb: '0',
    NoOustanding: 'There are currently no outstanding recalls for your ',
    PullingRecalls: 'We are pulling your recalls right now. Please wait...',
    ManuRecalls: 'Manufacturer Recalls',
    InitiatedRcl: 'has initiated the following recalls on your',
    AddToAppt: 'Select any to add to an appointment.',
    CheckRcl: 'Click the button below to check if there are any outstanding manufacturer recalls on your vehicle.',
    VinDecodeError: 'VIN Decode Error',
    VinDecodeMsg: 'Sorry, we were unable to decode your VIN.  Please try again.',
    VinOwnedMsg: 'Sorry, this vin is already owned by a customer.',
    ROHistory: 'Repair History',
    ROHistoryMsg: 'Click on the Repair Number to view more details.  If you want to save or print any of these documents, ',
    ClickHere: 'click here.',
    Repair: 'Repair',
    Price: 'Price',
    Description: 'Description',
    NoTimeAdvAvailLit: 'Your last Advisor has no time slots available for appointments.  Please select Different Time below so you can switch Advisors.',
    NoTimeTransAvailLit: 'Your last transportation type has no time slots available for appointments.  Please select Different Time below to switch transportation types.',
    WhichVeh: 'Which vehicle would you like to view or edit?',
    ClickResetPass: 'Click the Reset Password button below to change your password.',
    ResetPassEmailSent: 'An email to reset your password has been sent to {0}. Please click the link in your email to finish changing your password.',
    RepairDetails: 'Repair Details',
    SavePrintInvoice: 'SAVE/PRINT INVOICE',
    Concern: 'Concern',
    Cause: 'Cause',
    Correction: 'Correction',
    Previous: '<< Previous',
    More: 'More >>',
    Operations: 'Operations',
    InvoiceTotal: 'Invoice Total',
    PrintSave: 'Print/Save',
    InvoicedOn: 'Invoiced on',
    ROOpenedOn: 'Repair Order opened on',
    RO: 'RO#',
    DecodeVin: 'Decode VIN',
    AppointmentError: 'Error:',
    WhatsHappening: 'Here is what\'s happening with your',
    NoServices: `You haven't selected any services yet. Please select a service to continue.`,
    MyCart: 'My Cart',
    Pdi: 'PDI',
    ServicesOn: 'Services on appointment',
    VinCreateError: 'Add Vehicle Error',
    VinCreateErrorOwned: 'This vehicle is already owned by another customer. Please enter a new VIN.',
	VehicleAddError: `We are having trouble adding your vehicle at this time. Please make sure the VIN is correctly entered.`,
    Closed: 'Closed',
    MultApptSch: 'You have multiple appointments scheduled.',
    ApptSelInfo: 'Click on the Appointment Number to view more details.',
    ApptNumber: 'Appt. Number',
    NoRecalls: 'No Recalls were found for your vehicle.',
    Logout: 'Logout',
    vehWhichRecall: 'Which vehicle would you like to check for manufacturer recalls?',
    vehWhichRecom: 'Which vehicle would you like to check for previously recommended services?',
    vehWhichHistory: 'Which vehicle would you like to view repair history for?',
    VehNoRepair: 'There is no repair history for this vehicle.',
    VehNoPrev: 'There are no previously recommended services for this vehicle.',
    MoreDtls: 'More Details',
    LessDtls: 'Less Details',
    LoginTip: 'Click to log in to your online account',
    AddSvcTip: 'Click to add this service to your cart',
    AddSvcsTip: 'Click to add services to your appointment',
    ProceedTip: 'Click to move forward to the next step',
    Select: 'Click to select',
    NoAdvisorTip: 'Click to proceed with no advisor preferences for your appointment',
    ChooseAdvisorTip: 'Click to choose this advisor for your appointment',
    ImNewTip: 'Click to proceed as a new customer',
    AltTimeTip: 'Click to choose an alternate time for your appointment',
    ExistingCustTip: 'Click to proceed as an existing dealership customer',
    SkipServcTip: 'Click to skip adding services and proceed to choosing your appointment time',
    SkipRecSvcsTip: 'Click to skip adding recommended services and proceed to choosing other services',
    CreateAcctTip: 'Click to create an online owner account',
    UpdateApptTip: 'Click to view your appointment date, time, advisor, and transportation',
    UpdateVehTip: 'Click to view your appointment vehicle',
    SelectDateTip: 'Click to choose this date for your appointment',
    SavePrintTip: 'Save or print this document',
    RecomMaintTip: 'Click to view recommended maintenance for your vehicle',
    ViewServcTip: 'Click to view a list of vehicle services we offer',
    WriteYourOwnTip: 'Click to type out your specific service needs or self-diagnose your vehicle',
    ChangeApptTip: 'Make changes to your scheduled appointment',
    ManuRecallTip: 'Click to check for open manufacturer recalls for your vehicle',
    SelfDiagnoseTip: 'Click to add your self-diagnosis issue to your appointment',
    AddCustomTip: 'Click to add your custom issue to your appointment',
    SkipSvcsTip: 'Click to skip adding services and select an appointment time',
    CurrentRepair: 'Current Repair',
    HereCurrentStatus: 'Here is the current status of your ',
    BeingWorkedOn: ' being worked on.',
    StatusFinished: 'Finished',
    StatusInProgress: 'In Progress',
    YourVehicleCurrentlyStep: 'Your vehicle is currently on step ',
    Of: ' of ',
    YourVehicleCurrently: 'Your vehicle status is: ',
    Status: 'Status: ',
    RepairOrderNum: 'Repair Order # ',
    VehicleStatus: 'Vehicle Status',
    Dollar: '$ ',
    InvoiceReady: 'Invoice Ready to Pay',
    BillReady: ', your bill is ready to pay online.',
    PayNow: 'Pay Now',
    InvoicePaid: 'Invoice Paid',
    PaymentReceived: ', your payment online has been received.',
    ViewInvoice: 'View Invoice',
    YourAdvisor: 'Your Advisor',
    WeFound: ', we found ',
    ItemsInspectionAttention: ' items during your inspection that need your attention.',
    ItemInspectionAttention: ' item during your inspection that needs your attention.',
    Approved: ' Approved ',
    Declined: ' Declined',
    ItemsDuringInspection: ' items during your inspection. Action has been taken on them.',
    InspectionResults: 'Inspection Results',
    ViewResults: 'View results here.',
    Complete: 'Complete',
    AccountExists: 'Account Exists',
    MultipleRepairs: 'You currently have multiple repairs in progress.',
    NoRepairs: 'You currently have no open repairs.',
    RepairDate: 'Repair Date',
    RepairNumber: 'Repair Number',
    NoTimes: 'No available times were found for the selected date and advisor. Please choose a different date or advisor.',
    NoTimesInTimeRange: 'There are no times for the selected time range. Please choose a different range or day.',
    NoTimesForServices: 'No available times were found for the selected services',
    UpTo: 'Up to',
    StartingAt: 'Starting at',
    SignedIn: 'Signed In',
    VinHandy: 'Do you have your VIN handy? Enter it below.',
    UpcomingClosures: 'Upcoming Closures',
    ConfirmationViewAccount: 'Would you like to view your account?',
    ViewAccount: 'View Account',
    LogOff: 'Log Off',
    Confirm: 'Confirm',
    WhichVehicleAddingAppt: 'Which vehicle are you adding this appointment for?',
    ViewAcctOptBackIn1: 'You have previously opted out of receiving text messages from us. To receive text messages from us again, you will need to text YES to ',
    ViewAcctOptBackIn2: '. Once you have completed that step, return here and select "Okay" to let the system check your opt in status.',
    ViewAcctOptBackInFail: 'We haven\'t received your opt in message. To receive text messages from us again, you will need to text YES to ',
    ViewAcctOptBackInFail2: '. If you do not wish to opt in, select Cancel and switch to email as your preferred method of communication.',
    Okay: 'Okay',
    InvalidTokenError: `Invalid Service Portal URL. Make sure the URL has the correct token.`,
    ExpiredTokenError: 'The URL used to access Service Portal has expired',
    ModifyAppointment: 'Reschedule Appointment',
    UpdateServices: 'Update Services Requested',
    UpdateVehicle: 'Update Vehicle Information',
    ResetPasswordContactDeal: 'We are unable to reset your password at this time. Please contact the dealership to get a new password.',
    PleaseEnterEmail: 'Please enter your email above.',
    EmailSent: 'Email Sent',
    Missed: 'Missed',
    PleaseSelectService: 'Please select a service to continue.',
    ReasonForVisit: 'Reason for Visit',
    ServiceDocsGreeting: 'Here are the documents for your {0} from your service visit on:',
    ServiceDocsDefaultTitle: 'View Service Documents',
    ServiceDocsNotAvail: 'Documents for this service visit are not available. Please contact the dealership at {0} with any questions you have about this visit.',
    UpdatedColon: 'Updated: ',
    PendingRecommendations: 'Your vehicle has {0} Recommendations!',
    ExclamationPoint: '!',
    CriticalRecommendations: 'Your vehicle has Critical Recommendations!',
    Click: 'Click',
    Here: 'here',
    ViewInspectionResults: ' to view your Inspection Results.',
    OpenRepairOrderMessage: `Additional documents may be added. Please check back for updates.`,
    TimerDays: 'days',
    TimerDay: 'day',
    TimerHours: 'hours',
    TimerHour: 'hour',
    TimerMinute: 'minute',
    TimerMinutes: 'minutes',
    And: 'and',
    VinExistsMsg: 'You already own this vehicle.  Would you like to view it?',
    VinExistsApptMsg: 'You already own this vehicle. Would you like to make an appointment for it?',
    EmailUsed: 'Email Used',
    EmailUsedMsg: 'An account already exists for {0}. Please enter a different email. Your other updates will be saved.',
    EmailUsedMsgNoSave: 'An account already exists for {0}. Please enter a different email.',
    LosingVehicle: 'Losing Vehicle',
    LoseAddedVehicleWarning: 'If the appointment is not completed your new vehicle will not be added to the garage. Would you like to continue backing out?',
    CurrentStatus: 'Current Status',
    RecallOp: 'RECALL: ',
    TroubleLit: 'We are having trouble ',
    MessageAdding: 'adding',
    MessageUpdating: 'updating',
    ApptTimeLit: ' your appointment at this time.  Please try again in a few minutes.',
    IssuContLit: ' If the issue continues, please contact us at ',
    OurSpecialServices: 'Our Special Services:',
    Oops: 'Oops, Something Went Wrong',
    NetworkError: 'We are unable to access Service Portal at this time. Please try again in a few minutes.',
    AcctTimeLit: ' your account information at this time.  Please try again in a few minutes.',
    CancelAppt: 'Cancel Appointment',
    AreYouSure: 'Are you sure you want to cancel your appointment?',
    GoBack: 'Go Back',
    AddAppt: 'Add Appointment',
    ThankYou: 'Thank You!',
    ApptCanceled: 'Your appointment has been cancelled.',
    CreateNewAppt: 'Would you like to create a new appointment?',
    UpdateInfo: 'Update Info',
    Save: 'Save',
    ClickToUpdate: 'Click to update your information',
    ClickToSave: 'Click to save your changes',
    Warranty: 'Warranty',
    DropOff: 'Drop off vehicle before ',
    BeforeLit: 'Before ',
    ApptUnavailable: 'Appointment Unavailable',
    SelectNewAdv: 'The advisor, date, or time that you originally selected is no longer available. Please select another advisor, date, or time.',
    HereApptAdv: 'Here are some appointment times for Advisor:',
    Cancelling: 'cancelling',
    OkLit: 'Ok',
    ACSTooltip: 'Click to Open the Accessibility Control Panel',
    CartTooltip: 'Click to access your requested services',
    SelectTheYear: 'Select the year',
    Other: 'Other',
    CheckRecalls: 'Check Recalls',
    Unknown: 'Unknown',
    RememberDevice: 'Remember this device',
    ConfirmUpdates: 'Confirm Updates',
    NoServicesSelected: 'You do not have any services selected.  Please',
    NoServicesClickHere: 'click here',
    ToSelectAService: 'to select a service.',

    Unassigned: 'Unassigned',
    PicsVideos: 'Pictures/Videos',
    SelectThumbnail: 'Select a thumbnail to view a larger image and additional information',
    DownloadSelected: 'Download Selected',
    LastServiced: 'Last Serviced',
    MenuViewInspectionResults: 'View Inspection Results',
    CheckRepairStatus: 'Check Repair Status',
    ScheduleService: 'Schedule Service',
    ViewVehicleServiceHistory: 'View Vehicle Service History',
    YourModelsHistory: 'Your {0}\'s Service History',
    ViewHistoryPrepOn: 'Prepared on {0} for:',
    Comments: 'Comments',
    Recommendations: 'Recommendations',
    RepairOrder: 'Repair Order',
    Odometer: 'Odometer',
    Job: 'Job',
    Technicians: 'Technician(s)',
    WarrClaimNum: 'Warranty Claim #',
    WarrOperation: 'Warranty Operation',
    Customer: 'Customer',
    Internal: 'Internal',
    Complaint: 'Complaint',
    CampaignNum: 'Campaign #',
    RNDDEFull: 'Recommended Not Done / Done Elsewhere / Declined',
    Campaign: 'Campaign',
    Phone: 'Phone',
    VINAcronym: 'VIN',
    Notes: 'Notes',
    CodeSent: 'Code sent!',
    IdentityVerification: 'Identity Verification',
    SecurityString1: 'The security of your personal information is important to us. ',
    SecurityString2: 'Please verify your identity using a security code to log into your account.',
    SecurityString3: 'Please verify your identity using a security code to view or edit your personal information.',
    SecurityString4: 'Please verify your identity using a security code to view your vehicle\'s service documents.',
    SelectAuthMethod: 'Please select a phone number or email address to receive a security code: ',
    MaxAttemptsExceeded: 'The maximum number of attempts has been exceeded. Please request a new authentication code.',
    Verify: 'Verify',
    CodeError: 'Security Code must be 6 digits',

    UpdateMileage: 'Please update your vehicle\'s mileage.',
	UpdateMilStart: 'Your previous mileage was ',
    UpdateMilMid: ' miles. ',
	UpdateMilEnd: 'Please enter an updated estimated mileage. ',
    UpdateMilLess: 'The entered mileage must be greater than or equal to your previous mileage.',
    Choose: 'Choose',
    SaveAs: 'Save As',
    ClickHereMoreDtl: 'Click here for more details.',

    // WriteYourOwn Dialog Literals
    WhichApplies: 'Which of the following applies?',
    IFeelIt: 'I Feel it (hesitation, shimmer, vibration, etc.)',
    Feel: 'Feel',
    IFeel: 'I Feel...',
    VehicleDrift: 'The vehicle drifting or pulling to one side',
    VehicleDriftTo: 'I feel the vehicle drifting or pulling to the...',
    Left: 'Left',
    VehicleDriftToLeft: 'I feel the vehicle drifting or pulling to the left.',
    Right: 'Right',
    VehicleDriftToRight: 'I feel the vehicle drifting or pulling to the right.',
    PlaySteeringWheel: 'Excessive play in the steering wheel',
    FeelPlaySteeringWheel: 'I feel excessive play or looseness in the steering wheel.',
    PulsingVibrations: 'Pulsing or vibrations',
    FeelPulsingVibrations: 'I feel pulsing or vibrations coming from...',
    FrontVehicle: 'Front of the vehicle',
    PulsingVibrationsFront: 'I feel pulsing or vibrations coming from the front of the vehicle...',
    WhenAccelerating: 'When accelerating',
    PulsingVibrationsFrontAccelerating: 'I feel pulsing or vibrations coming from the front of the vehicle when accelerating.',
    RearVehicle: 'The rear of the vehicle',
    PulsingVibrationsRear: 'I feel pulsing or vibrations coming from the rear of the vehicle...',
    PulsingVibrationsRearAccelerating: 'I feel pulsing or vibrations coming from the rear of the vehicle when accelerating.',
    WhenBraking: 'When braking',
    PulsingVibrationsFrontBraking: 'I feel pulsing or vibrations coming from the front of the vehicle when braking.',
    PulsingVibrationsRearBraking: 'I feel pulsing or vibrations coming from the rear of the vehicle when braking.',
    HigherSpeeds: 'At higher speeds',
    PulsingVibrationsRearHigh: 'I feel pulsing or vibrations coming from the rear of the vehicle when driving at higher speeds.',
    PulsingVibrationsFrontHigh: 'I feel pulsing or vibrations coming from the front of the vehicle when driving at higher speeds.',
    AllTheTime: 'All the time',
    PulsingVibrationsRearAll: 'I feel pulsing or vibrations coming from the rear of the vehicle all the time.',
    PulsingVibrationsFrontAll: 'I feel pulsing or vibrations coming from the front of the vehicle all the time.',
    None: 'None of these',
    PulsingVibrationsFrontNone: 'I feel pulsing or vibrations coming from the front of the vehicle.',
    PulsingVibrationsRearNone: 'I feel pulsing or vibrations coming from the rear of the vehicle.',
    SteeringWheel: 'The steering wheel',
    PulsingVibrationsSteeringWheel: 'I feel pulsing or vibrations coming from the steering wheel...',
    PulsingVibrationsSteeringWheelAccelerating: 'I feel pulsing or vibrations coming from the steering wheel when accelerating.',
    PulsingVibrationsSteeringWheelBraking: 'I feel pulsing or vibrations coming from the steering wheel when braking.',
    WhenTurning: 'When turning',
    PulsingVibratingSteeringWheelTurning: 'I feel pulsing or vibrations coming from the steering wheel when turning.',
    PulsingVibratingSteeringWheelSpeeds: 'I feel pulsing or vibrations coming from the steering wheel when driving at higher speeds.',
    PulsingVibratingSteeringWheelAll: 'I feel pulsing or vibrations coming from the steering wheel all the time.',
    PulsingVibrationsSteeringWheelNone: 'I feel pulsing or vibrations coming from the steering wheel.',
    PulsingVibrationsVehicle: 'I feel pulsing or vibrations coming from my vehicle.',
    Swaying: 'The vehicle swaying',
    SwayingSideToSide: 'I feel the vehicle swaying side to side.',
    FeelsDifferent: 'The vehicle feels differently than normal.',
    IHearIt: 'I Hear it (rattle, knock, squeal, etc.)',
    Hear: 'Hear',
    IHear: 'I hear...',
    SquealingChirping: 'Squealing or Chirping',
    SquealingChirpingFrom: 'I hear a squealing or chirping sound coming from...',
    TheEngine: 'The engine compartment',
    SquealingChirpingEngine: 'I hear a squealing or chirping sound coming from the engine compartment...',
    SquealingChirpingEngineAll: 'I hear a squealing or chirping sound coming from the engine compartment all the time.',
    WhenStopping: 'When stopping',
    SquealingChirpingEngineStopping: 'I hear a squealing or chirping sound coming from the engine compartment when stopping.',
    OnlyWhenStarting: 'Only when starting the vehicle',
    SquealingChirpingEngineStarting: 'I hear a squealing or chirping sound coming from the engine compartment only when starting the vehicle.',
    OnlyWhenTurning: 'Only when turning the vehicle',
    SquealingChirpingEngineTurning: 'I hear a squealing or chirping sound coming from the engine compartment only when turning the vehicle.',
    OnlyWhileMoving: 'Only while the vehicle is moving',
    SquealingChirpingEngineMoving: 'I hear a squealing or chirping sound coming from the engine compartment only when the vehicle is moving.',
    SquealingChirpingEngineNone: 'I hear a squealing or chirping sound coming from the engine compartment.',
    Interior: 'The interior of the vehicle',
    SquealingChirpingInterior: 'I hear a squealing or chirping sound coming from the interior of the vehicle...',
    SquealingChirpingInteriorAll: 'I hear a squealing or chirping sound coming from the interior of the vehicle all the time.',
    HeatOrAC: 'Only when the heat or AC is on',
    SquealingChirpingInteriorHeatAC: 'I hear a squealing or chirping sound coming from the interior of the vehicle when the heat or AC is on.',
    SquealingChirpingInteriorNone: 'I hear a squealing or chirping sound coming from the interior of the vehicle.',
    Under: 'Under the vehicle',
    SquealingChirpingUnder: 'I hear a squealing or chirping sound coming from under the vehicle...',
    SquealingChirpingUnderAll: 'I hear a squealing or chirping sound coming from under the vehicle all the time.',
    SquealingChirpingUnderStopping: 'I hear a squealing or chirping sound coming from under the vehicle when stopping.',
    SquealingChirpingUnderTurning: 'I hear a squealing or chirping sound coming from under the vehicle only when turning the vehicle.',
    SquealingChirpingUnderMoving: 'I hear a squealing or chirping sound coming from under the vehicle only while the vehicle is moving.',
    SquealingChirpingUnderNone: 'I hear a squealing or chirping sound coming from under the vehicle.',
    Hissing: 'Hissing',
    HearHissing: 'I hear a hissing sound coming from...',
    HissingEngine: 'I hear a hissing sound coming from the engine compartment...',
    HissingEngineAll: 'I hear a hissing sound coming from the engine compartment all the time.',
    HissingEngineStarting: 'I hear a hissing sound coming from the engine compartment when starting the vehicle.',
    HissingEngineMoving: 'I hear a hissing sound coming from the engine compartment only while the vehicle is moving.',
    HissingEngineNone: 'I hear a hissing sound coming from the engine compartment.',
    HissingInterior: 'I hear a hissing sound coming from the interior of the vehicle...',
    HissingInteriorAll: 'I hear a hissing sound coming from the interior of the vehicle all the time.',
    HissingInteriorHeatAC: 'I hear a hissing sound coming from the interior of the vehicle only when the heat or AC is on.',
    HissingInteriorNone: 'I hear a hissing sound coming from the interior of the vehicle.',
    FromTire: 'From the tire',
    HissingTire: 'I hear a hissing sound coming from the tire on...',
    DriversSideFront: 'The driver\'s side front of the vehicle',
    HissingTireDriversSideFront: 'I hear a hissing sound coming from the tire on the driver\'s side front of the vehicle.',
    DriversSideRear: 'The driver\'s side rear of the vehicle',
    HissingTireDriversSideRear: 'I hear a hissing sound coming from the tire on the driver\'s side rear of the vehicle.',
    PassengersSideFront: 'The passenger\'s side front of the vehicle',
    HissingTirePassengersSideFront: 'I hear a hissing sound coming from the tire on the passenger\'s side front of the vehicle.',
    PassengersSideRear: 'The passenger\'s side rear of the vehicle',
    HissingTirePassengersSideRear: 'I hear a hissing sound coming from the tire on the passenger\'s side rear of the vehicle.',
    OtherTire: 'Other (spare tire, etc)',
    HissingOtherTire: 'I hear a hissing sound from a tire.',
    HissingNone: 'I hear a hissing sound.',
    Knocking: 'Knocking',
    HearKnocking: 'I hear a knocking sound...',
    HearKnockingAll: 'I hear a knocking sound all the time.',
    KnockingStarting: 'I hear a knocking sound when starting the vehicle.',
    KnockingNone: 'I hear a knocking sound.',
    Tapping: 'Tapping',
    HearTapping: 'I hear a tapping sound coming from...',
    TappingEngine: 'I hear a tapping sound coming from the engine compartment...',
    TappingEngineAll: 'I hear a tapping sound coming from the engine compartment all the time.',
    TappingEngineStarting: 'I hear a tapping sound coming from the engine compartment only when starting the vehicle.',
    TappingEngineMoving: 'I hear a tapping sound coming from the engine compartment only while the vehicle is moving.',
    TappingEngineNone: 'I hear a tapping sound coming from the engine compartment.',
    TappingUnder: 'I hear a tapping sound coming from under the vehicle...',
    TappingUnderAll: 'I hear a tapping sound coming from under the vehicle all the time.',
    TappingUnderStarting: 'I hear a tapping sound coming from under the vehicle only when starting the vehicle.',
    TappingUnderMoving: 'I hear a tapping sound coming from under the vehicle only while the vehicle is moving.',
    TappingUnderNone: 'I hear a tapping sound coming from under the vehicle.',
    TappingNone: 'I hear a tapping sound.',
    Rattle: 'A rattle',
    HearRattle: 'I hear a rattle coming from...',
    RattleEngine: 'I hear a rattle coming from the engine compartment...',
    RattleEngineAll: 'I hear a rattle coming from the engine compartment all the time.',
    RattleEngineStarting: 'I hear a rattle coming from the engine compartment only when starting the vehicle.',
    RattleEngineMoving: 'I hear a rattle coming from the engine compartment only while the vehicle is moving.',
    RattleEngineNone: 'I hear a rattle coming from the engine compartment.',
    RattleUnder: 'I hear a rattle coming from under the vehicle.',
    RattleInterior: 'I hear a rattle coming from the interior of the vehicle...',
    RattleInteriorAll: 'I hear a rattle coming from the interior of the vehicle all the time.',
    RattleInteriorHeatAC: 'I hear a rattle coming from the interior of the vehicle only when the heat or AC is on.',
    RattleInteriorNone: 'I hear a rattle coming from the interior of the vehicle.',
    RattleNone: 'I hear a rattle.',
    Grinding: 'Grinding',
    HearGrinding: 'I hear grinding coming from...',
    GrindingEngine: 'I hear grinding coming from the engine compartment...',
    GrindingEngineAll: 'I hear grinding coming from the engine compartment all the time.',
    GrindingEngineStopping: 'I hear grinding coming from the engine compartment only when stopping.',
    GrindingEngineStarting: 'I hear grinding coming from the engine compartment only when starting the vehicle.',
    GrindingEngineTurning: 'I hear grinding coming from the engine compartment only when turning.',
    GrindingEngineNone: 'I hear grinding coming from the engine compartment.',
    GrindingUnder: 'I hear grinding coming from under the vehicle...',
    GrindingUnderAll: 'I hear grinding coming from under the vehicle all the time.',
    GrindingUnderStopping: 'I hear grinding coming from under the vehicle when stopping.',
    GrindingUnderTurning: 'I hear grinding coming from under the vehicle only when turning.',
    GrindingUnderNone: 'I hear grinding coming from under the vehicle.',
    GrindingNone: 'I hear grinding.',
    Clunk: 'A Clunk',
    HearClunk: 'I hear a clunk from...',
    ClunkEngine: 'I hear a clunk coming from the engine compartment...',
    ClunkEngineTurning: 'I hear a clunk from the engine compartment only when turning.',
    Bumps: 'When going over bumps',
    ClunkEngineBumps: 'I hear a clunk from the engine compartment only when going over bumps.',
    Gear: 'When putting the vehicle in gear',
    ClunkEngineGear: 'I hear a clunk from the engine compartment when putting the vehicle in gear.',
    ClunkEngineNone: 'I hear a clunk from the engine compartment.',
    ClunkUnder: 'I hear a clunk coming from under the vehicle...',
    ClunkUnderTurning: 'I hear a clunk coming from under the vehicle only when turning.',
    ClunkUnderBumps: 'I hear a clunk coming from under the vehicle when going over bumps.',
    ClunkUnderGear: 'I hear a clunk coming from under the vehicle when putting the vehicle in gear.',
    ClunkUnderNone: 'I hear a clunk coming from under the vehicle.',
    ClunkNone: 'I hear a clunk.',
    SoundNone: 'The vehicle sounds differently than normal.',
    ISeeIt: 'I See it (oil leak, warning light, etc.)',
    See: 'See',
    ISee: 'I see...',
    Smoke: 'Smoke',
    SeeSmoke: 'I see smoke coming from...',
    SeeSmokeEngine: 'I see smoke coming from the engine compartment...',
    AppearsBlack: 'And it appears black',
    BlackSmokeEngine: 'I see black smoke coming from the engine compartment.',
    AppearsBlue: 'And it appears blue',
    BlueSmokeEngine: 'I see blue smoke coming from the engine compartment.',
    AppearsWhite: 'And it appears white',
    WhiteSmokeEngine: 'I see white smoke coming from the engine compartment.',
    SmokeEngineNone: 'I see smoke coming from the engine compartment.',
    ExhaustPipe: 'The exhaust pipe',
    SmokeExhaust: 'I see smoke coming from the exhaust pipe...',
    SmokeExhaustBlack: 'I see black smoke coming from the exhaust pipe.',
    SmokeExhaustBlue: 'I see blue smoke coming from the exhaust pipe.',
    SmokeExhaustWhite: 'I see white smoke coming from the exhaust pipe.',
    SmokeExhaustNone: 'I see smoke coming from the exhaust pipe.',
    SmokeInterior: 'I see smoke coming from the interior of the vehicle.',
    PuddleLeak: 'A Puddle or Leak',
    SeePuddleLeak: 'I see a puddle or leak coming from...',
    PuddleLeakEngine: 'I see a puddle or leak coming from the engine compartment and it looks like...',
    EngineOil: 'Engine Oil (brown-black)',
    PuddleLeakEngineOil: 'I see a puddle or leak of engine oil in the engine compartment.',
    TransmissionFluid: 'Transmission Fluid (red-brown)',
    PuddleLeakEngineTransmissionFluid: 'I see a puddle or leak of transmission fluid in the engine compartment.',
    PowerSteeringFluid: 'Power Steering Fluid (red-pink)',
    PuddleLeakEnginePowerSteeringFluid: 'I see a puddle or leak of power steering fluid in the engine compartment.',
    Coolant: 'Coolant (green or orange-yellow)',
    PuddleLeakEngineCoolant: 'I see a puddle or leak of coolant in the engine compartment.',
    Gasoline: 'Gasoline',
    PuddleLeakEngineGasoline: 'I see a puddle or leak of gasoline in the engine compartment.',
    PuddleLeakEngineNone: 'I see a leak or puddle in the engine compartment.',
    PuddleLeakUnder: 'I see a puddle or leak under the vehicle and it looks like...',
    PuddleLeakUnderEngineOil: 'I see a puddle or leak of engine oil under the vehicle.',
    PuddleLeakUnderTransmissionFluid: 'I see a puddle or leak of transmission fluid under the vehicle.',
    PuddleLeakUnderPowerSteeringFluid: 'I see a puddle or leak of power steering fluid under the vehicle.',
    PuddleLeakUnderCoolant: 'I see a puddle or leak of coolant under the vehicle.',
    PuddleLeakUnderGasoline: 'I see a puddle or leak of gasoline under the vehicle.',
    PuddleLeakUnderNone: 'I see a puddle or leak under the vehicle.',
    PuddleLeakInterior: 'I see a puddle or leak in the interior of the vehicle and it looks or smells like...',
    Water: 'Water',
    PuddleLeakInteriorWater: 'I see a puddle or leak of water inside the vehicle.',
    Refrigerant: 'Refrigerant (chemical smell)',
    PuddleLeakInteriorRefrigerant: 'I see a puddle or leak of refrigerant inside the vehicle.',
    CoolantSmell: 'Coolant (chemical smell)',
    PuddleLeakInteriorCoolant: 'I see a puddle or leak of coolant inside the vehicle.',
    PuddleLeakInteriorNone: 'I see a puddle or leak inside the vehicle.',
    LowFlatTire: 'A Low or Flat Tire',
    SeeLowFlatTire: 'I see a low or flat tire...',
    OnDriversSideFront: 'On the driver\'s side front of the vehicle',
    LowFlatTireDriversSideFront: 'I see a low or flat tire on the driver\'s side of the front of the vehicle.',
    OnDriversSideRear: 'On the driver\'s side rear of the vehicle',
    LowFlatTireDriversSideRear: 'I see a low or flat tire on the driver\'s side of the rear of the vehicle.',
    OnPassengersSideFront: 'On the passenger\'s side front of the vehicle',
    LowFlatTirePassengersSideFront: 'I see a low or flat tire on the passenger\'s side of the front of the vehicle.',
    OnPassengersSideRear: 'On the passenger\'s side rear of the vehicle',
    LowFlatTirePassengersSideRear: 'I see a low or flat tire on the passenger\'s side of the rear of the vehicle.',
    LowFlatTireNone: 'I see a low or flat tire.',
    WarningLight: 'A Warning Light',
    ISeeThe: 'I see the...',
    CheckEngineLight: 'Check Engine light',
    SeeCheckEngineLight: 'I see the check engine light and it is...',
    OccasionallyOn: 'Occasionally on',
    CheckEngineLightOccasionally: 'I see the check engine light occasionally.',
    ConstantlyOn: 'Constantly on',
    CheckEngineLightConstantly: 'I see the check engine light constantly.',
    TirePressureWarning: 'Tire Pressure Warning',
    SeeTirePressureWarning: 'I see the tire pressure warning and it is...',
    TirePressureWarningOccasionally: 'I see the tire pressure warning occasionally.',
    TirePressureWarningConstantly: 'I see the tire pressure warning constantly.',
    CoolantTemperatureWarning: 'Coolant/Temperature Warning',
    SeeCoolantTemperatureWarning: 'I see the coolant/temperature warning and it is...',
    CoolantTemperatureWarningOccasionally: 'I see the coolant/temperature warning occasionally.',
    CoolantTemperatureWarningConstantly: 'I see the coolant/temperature warning constantly.',
    BatteryChargeWarning: 'Battery Charge Warning',
    SeeBatteryChargeWarning: 'I see the battery charge warning and it is...',
    BatteryChargeWarningOccasionally: 'I see the battery charge warning occasionally.',
    BatteryChargeWarningConstantly: 'I see the battery charge warning constantly.',
    OilPressureWarning: 'Oil Pressure warning',
    SeeOilPressureWarning: 'I see the oil pressure warning and it is...',
    OilPressureWarningOccasionally: 'I see the oil pressure warning occasionally.',
    OilPressureWarningConstantly: 'I see the oil pressure warning constantly.',
    BrakeABSWarning: 'Brake/ABS warning',
    SeeBrakeABSWarning: 'I see the brake/ABS warning and it is...',
    BrakeABSWarningOccasionally: 'I see the brake/ABS warning occasionally.',
    BrakeABSWarningConstantly: 'I see the brake/ABS warning constantly.',
    StabilityTractionWarning: 'Stability/Traction warning',
    SeeStabilityTractionWarning: 'I see the stability/traction warning and it is...',
    StabilityTractionWarningOccasionally: 'I see the stability/traction warning occasionally.',
    StabilityTractionWarningConstantly: 'I see the stability/traction warning constantly.',
    OtherWarningLight: 'Other warning light or message',
    WarningLightOther: 'I see a warning light or message.',
    SomethingLooksDifferent: 'Something looks different about my vehicle than normal.',
    ISmellIt: 'I Smell it (gasoline, rotten eggs, burning, etc.)',
    Smell: 'Smell',
    ISmell: 'I smell...',
    SmellGasoline: 'I smell gasoline...',
    SmellGasolineEngine: 'I smell gasoline in the engine compartment...',
    SmellGasolineEngineAll: 'I smell gasoline in the engine compartment all the time.',
    EngineRunning: 'Only when the engine is running',
    SmellGasolineEngineRunning: 'I smell gasoline in the engine compartment only when the engine is running.',
    SmellGasolineEngineNone: 'I smell gasoline in the engine compartment.',
    SmellGasolineUnder: 'I smell gasoline under the vehicle...',
    SmellGasolineUnderAll: 'I smell gasoline under the vehicle all the time.',
    SmellGasolineUnderRunning: 'I smell gasoline under the vehicle only when the engine is running.',
    SmellGasolineUnderNone: 'I smell gasoline under the vehicle.',
    SmellGasolineNone: 'I smell gasoline around my vehicle.',
    RottenEggsSulfur: 'Rotten eggs or sulfur',
    SmellRottenEggsSulfur: 'I smell rotten eggs or sulfur coming from my vehicle.',
    Mildew: 'Mildew',
    SmellMildew: 'I smell mildew...',
    SmellMildewAll: 'I smell mildew coming from my vehicle all the time.',
    SmellMildewHeatAC: 'I smell mildew coming from my vehicle only when the heat or AC is on.',
    SmellMildewNone: 'I smell mildew coming from my vehicle.',
    Antifreeze: 'Antifreeze (sweet smell)',
    SmellAntrifreeze: 'I smell antifreeze in the...',
    SmellAntiFreezeEngine: 'I smell antifreeze in the engine compartment.',
    SmellAntiFreezeInterior: 'I smell antifreeze in the interior of my vehicle...',
    SmellAntiFreezeInteriorAll: 'I smell antifreeze in the interior of my vehicle all the time.',
    OnlyWhenHeat: 'Only when the heat is on',
    SmellAntiFreezeInteriorHeat: 'I smell antifreeze in the interior of my vehicle only when the heat is on.',
    SmellAntifreezeNone: 'I smell antifreeze coming from my vehicle.',
    BurningOil: 'Burning oil',
    SmellBurningOil: 'I smell burning oil in the...',
    SmellBurningOilEngine: 'I smell burning oil in the engine compartment.',
    SmellBurningOilExhaust: 'I smell burning oil in the exhaust pipe.',
    SmellBurningOilNone: 'I smell burning oil coming from my vehicle.',
    ExhaustGas: 'Exhaust gas',
    SmellExhaustGas: 'I smell exhaust gas in the...',
    SmellExhaustGasEngine: 'I smell exhaust gas in the engine compartment...',
    OnlyDuringStartup: 'Only during startup',
    SmellExhaustGasEngineStartup: 'I smell exhaust gas in the engine compartment only when during startup.',
    SmellExhaustGasEngineAll: 'I smell exhaust gas in the engine compartment all the time.',
    SmellExhaustGasEngineNone: 'I smell exhaust gas in the engine compartment.',
    SmellExhaustGasInterior: 'I smell exhaust gas in the interior of my vehicle.',
    SmellExhaustGasNone: 'I smell exhaust gas coming from my vehicle.',
    SmellNone: 'Something smells different about my vehicle than normal.',
    VehicleNotFunction: 'My vehicle will Not Function (won\'t start, won\'t move, etc.)',
    NotFunction: 'Not Function',
    MyVehicles: 'My vehicle\'s...',
    EngineWontStart: 'Engine won\'t start',
    MyVehiclesEngine: 'My vehicle\'s engine...',
    StartsStalls: 'Starts then immediately stalls',
    EngineStartsStalls: 'My vehicle\'s engine starts then immediately stalls.',
    CranksWontRun: 'Cranks but won\'t run',
    EngineCranksWontRun: 'My vehicle\'s engine cranks but won\'t run.',
    DoesntCrank: 'Doesn\'t crank at all',
    EngineDoesntCrank: 'My vehicle\'s engine doesn\'t crank at all.',
    VehiclesEngineWontStart: 'My vehicle\'s engine won\'t start.',
    VentsWontBlowHot: 'Vents won\'t blow hot air',
    MyVehiclesVents: 'My vehicle\'s vents...',
    OnlyColdAir: 'Only has cold air blowing',
    VehicleOnlyColdAir: 'My vehicle only has cold air blowing from the vents.',
    WontBlowAir: 'Won\'t blow air at all',
    NoAir: 'My vehicle has no air blowing from the vents.',
    WontBlowHot: 'My vehicle\'s vents won\'t blow hot air.',
    VentsWontBlowCold: 'Vents won\'t blow cold air',
    OnlyWarmAir: 'Only has warm air blowing',
    VehicleOnlyWarmAir: 'My vehicle only has warm air blowing from the vents.',
    WontBlowCold: 'My vehicle\'s vents won\'t blow cold air.',
    EngineRunsVehicleWontMove: 'Engine runs but the vehicle won\'t move',
    VehiclesEngineRunsVehicleWontMove: 'My vehicle\'s engine runs, but the vehicle won\'t move.',
    MyVehicle: 'My vehicle will not function',
    OtherNone: 'Other (none of the above)',
    DescribeVehiclesIssue: 'Describe your vehicle\'s issue:',
    CalendarDesc: 'Your upcoming service appointment with',
    UpcomingServiceAppt: 'Your upcoming service appointment',
    SvcApptFor: 'Service Appointment for',
    Black: 'Black',
    Blue: 'Blue',
    Brown: 'Brown',
    Copper: 'Copper',
    Gold: 'Gold',
    Gray: 'Gray',
    Green: 'Green',
    Maroon: 'Maroon',
    Orange: 'Orange',
    Pink: 'Pink',
    Purple: 'Purple',
    Silver: 'Silver',
    Tan: 'Tan',
    Teal: 'Teal',
    Yellow: 'Yellow',
    SelectDiffTime: 'For more options, please select Different Time below.',
    LogOut: 'Log out',
    AddVehicleTitle: 'Add Vehicle',
    recallLink: 'https://www.nhtsa.gov/recalls',
    DaysLit: 'day(s)',
    HoursLit: 'hour(s)',
    MinutesLit: 'minute(s)',
    WeOwe: 'We Owe',
    ManufacturerRecall: 'Manufacturer Recall',
    ServicesOnRepair: 'Services on this repair.',
    EmptyFieldError: 'Entry required to proceed...',
    At: 'at',
    Please: 'Please ',
    SchNewAppt: 'Click to begin a new appointment',
    IdenticalPassword: 'New and old passwords are identical',
    NewPassword: 'Your new password cannot be the same as your current password.',
    ValidPhone: 'Please enter a valid 10-digit phone number.  XXX-XXX-XXXX',
	ValidEmail: 'Please enter a valid email address. A valid email address should include a username, domain, and a top-level domain. Example johndoe@domain.com',
    EmailOrPhone: 'Email or Phone Number *',
    ValidEmailPhone: 'Please enter a valid email address or 10-digit phone number',
    Edit: 'Edit',
    EditToolTip: 'Select Edit to view or change your information',
    CancelToolTip: 'Select Cancel to undo any changes made to your {0}',
    FirstNameLabel: 'First Name',
    LastNameLabel: 'Last Name',
    PhoneLabel: 'Phone',
    NoAvailTimes: 'No available times for the selected date',
    NotAvailDate: 'Not available for the selected date',
    SessionExpired: 'Your session has expired. Please refresh the page',
    ConnectedVehicle: 'CONNECTED VEHICLE',
    ConnectedVehicleStatus: 'Connected Vehicle Status',
	Client: 'Client',
	VINShort: 'VIN',
	LastDataRefresh: 'Last Data Refresh',
    VehMaintenance: 'VEHICLE MAINTENANCE',
    VehStatus: 'VEHICLE STATUS',
    DTCHeader: 'Diagnostic Trouble Codes',
	TroubleCode: 'Trouble Code',
	CVStatus: 'Status',
    DTCShort: 'DTC',
	EmissionDTC: 'Emission DTC',
	ECMECU: 'ECM/ECU',
	SymptomCode: 'Symptom Code',
    ViewVehicleBuildData: 'View Vehicle Build Data',
    ViewConnectedVehicleLog: 'View Connected Vehicle Log',
	ViewConnectedVehicleSettings: 'View Connected Vehicle Settings',
    ViewManufacturerInquiry: 'View Manufacturer Inquiry',
    ViewGeoLocation: 'View Geolocation',
    ViewServiceHistory: 'View Service History',
    ServiceHistory: 'Service History',
	FirstRepairOrderDate: 'First Repair Order Date',
	LastRepairOrderNumber: 'Last Repair Order #',
	LastRepairOrderDate: 'Last Repair Order Date',
	LastRepairOrderOdometer: 'Last Repair Order Odometer',
	RONum: 'RO',
	DealerCode: 'Dealer Code',
	LocationId: 'Location ID',
	OpenDate: 'Open Date',
	CompletedDate: 'Completed Date',
	InvoicedDate: 'Invoiced Date',
	OodmeterIn : 'Odometer In',
	OdometerOut: 'Out',
	JobNumber: 'Job Number',
	OperationId: 'Operation ID',
	OperationDescription: 'Description',
	LaborId: 'Labor ID',
	LaborHours: 'Labor Hours',
	LaborDescription: 'Labor Description',
	PartNumber: 'Part Number',
	PartQty: 'Part Qty',
	PartDescription: 'Part Description',
    BuildData: 'BUILD DATA',
	VehicleInformation: 'Vehicle Information',
    VehicleDetails: 'Vehicle Details',
	BuildCodes: 'Build Codes',
	ProductionDate: 'Production Date',
	Series: 'Series',
	ModelNumber: 'Model Number',
	ColorCode: 'Color (code)',
	InteriorCode: 'Interior (code)',
	MarketName: 'Market Name',
	BodyStyle: 'Body Style',
	OrderNumber: 'Order Number',
	ProductionPoint: 'Production Point',
	ProductionPlant: 'Production Plant (Code)',
    SerialNumber: 'Serial Number',
	AirConditioning: 'Air Conditioning',
	PowerSteering: 'Power Steering',
	Turbo: 'Turbo',
	LicenseNumber: 'License Number',
	NewUsed: 'New/Used',
	ChassisNumber: 'Chassis Number',
	KeyNumber: 'Key Number',
	SecondKeyNumber: 'Second Key Number',
	KeylessNumber: 'Keyless Number',
	KeychipNumber: 'Key Chip Number',
	AlarmNumber: 'Alarm Number',
	FrontSafetyRating: 'Front Safety Rating',
	RearSafetyRating: 'Rear Safety Rating',
	DriverSafetyRating: 'Driver Safety Rating',
	PassengerSafetyRating: 'Passenger Safety Rating',
	RolloverSafetyRating: 'Rollover Safety Rating',
	OverallSafetyRating: 'Overall Safety Rating',
	SeatingCapacity: 'Seating Capacity',
	GrossVehicleWeight: 'Gross Vehicle Weight',
	VehicleWeight: 'Vehicle Weight',
	EngineNumber: 'Engine Number',
	EngineConfiguration: 'Engine Configuration',
	EngineSize: 'Engine Size',
	EngineType: 'Engine Type',
	EngineCylinders: 'Engine Cylinders',
	BaseMSRP: 'Base MSRP',
	OptionMSRP: 'Option MSRP',
	TotalMSRP: 'Total MSRP',
	Freight: 'Freight',
	ModelPhaseCode: 'Model Phase Code',
	FuelCode: 'Fuel Code',
	FuelType: 'Fuel Type',
	FuelCapacity: 'Fuel Capacity',
	Transmission: 'Transmission',
	TransmissionCode: 'Transmission Code',
	TransmissionDescription: 'Transmission Description',
	StockId: 'Stock ID',
	CustomerNumber: 'Customer Number',
	SalesmanNumber: 'Salesman Number',
	ModelMaintenanceCode: 'Model Maintenance Code',
	SellingDealerNumber: 'Selling Dealer Number',
	InServiceDate: 'In Service Date',
	ProductionHour: 'Production Hour',
	DeliveryDate: 'Delivery Date',
	DeliveryOdometer: 'Delivery Odometer',
	DemoDate: 'Demo Date',
	DemoOdometer: 'Demo Odometer',
	FactoryWarrExpDate: 'Factory Warranty Expiration Date',
	FactoryWarrExpOdometer: 'Factory Warranty Expiration Odometer',
	ServiceDays: 'Service Days',
	TeamCode: 'Team Code',
	LastActivityDate: 'Last Activity Date',
	DriverWindowReedSensor: 'Driver Window Reed Sensor Pulses',
	PassengerWindowReedSensor: 'Passenger Window Reed Sensor Pulses',
	RearLeftWindowReedSensor: 'Rear Left Window Reed Sensor Pulses',
	RearRightWindowReedSensor: 'Rear Right Window Reed Sensor Pulses',
	SunroofReedSensor: 'Sunroof Reed Sensor Pulses',
	OptionDesc: 'Option Description',
	OptionCode: 'Code',
    ConnectedVehicleLog: 'CONNECTED VEHICLE LOG',
	EventDescription: 'Event Description',
	CVDate: 'Date',
	CVTime: 'Time',
	ERAUser: 'ERA User',
    ManufacturerInquiry: 'MANUFACTURER INQUIRY',
    VehicleLocation: 'Vehicle Location',
	LocationAsOf: 'Location as of',
	GpsStatus: 'GPS Status',
	GpsState: 'GPS State',
	Mileage: 'Mileage',
	BatteryCharge: 'Battery Charge',
	BatteryInformation: 'Battery Information',
	Battery: 'Battery',
	LastUpdated: 'Last Updated',
	BatteryStatus: 'Battery Status',
	BatteryHealthStatus: 'Battery Health Status',
	BatteryChargePercent: 'Battery Charge %',
	ElectricBatteryDTE: 'Electric Battery DTE',
	FuelLevel: 'Fuel Level',
	FuelInformation: 'Fuel Information',
	Fuel: 'Fuel',
	MilesPerFullTank: 'Miles Per Full Tank',
	CityMpg: 'City MPG',
	FuelEquivalentCityMpg: 'Fuel Equiv. City MPG',
	HighwayMpg: 'Highway MPG',
	FuelEquivalentHighwayMpg: 'Fuel Equiv. Highway MPG',
	CombinedMpg: 'Combined MPG',
	FuelEquivalentCombinedMpg: 'Fuel Equiv. Combined MPG',
	DistanceToEmpty: 'Distance To Empty',
	OilLife: 'Oil Life',
	OilInformation: 'Oil Information',
	Oil: 'Oil',
	OilStatus: 'Oil Status',
	OilAmount: 'Oil Amount',
	OilDescription: 'Oil Description',
    RemainingDistance: `Remaining Distance`,
	ReplaceOil: `Replace Oil`,
	ZeroDaysMonthsYears: `Zero Days/Months/Years`,
	LockStatus: 'Lock Status',
	Locked: 'Locked',
	Unlocked: 'Unlocked',
	Set: 'Set',
	NotSet: 'Not Set',
	Working: 'Working',
	NotWorking: 'Not Working',
	AlarmStatus: 'Alarm Status',
	RemoteStartStatus: 'Remote Start Status',
	RemoteStartInformation: 'Remote Start Information',
	RemoteStartCommand: 'Remote Start Command',
	RemoteStart: 'Remote Start',
	Duration: 'Duration',
	TimeRemaining: 'Time Remaining',
	ExhaustFluid: 'Exhaust Fluid',
	EngineAirFilter: 'Engine Air Filter',
	RepeatVisits: 'Repeat Visits',
    DeepSleep: 'Deep Sleep',
	FirmwareUpdate: 'Firmware Update',
	EvHybridData: 'EV/Hybrid Data',
    ViewEvHybridData: 'View EV/Hybrid Data',
	EvHybridInformation: 'Electronic Vehicle/Hybrid Information',
	PlugStatus: 'Plug Status',
	HybridChargingMode: 'Hybrid Charging Mode',
	ChargeStatus: 'Charge Status',
	ChargeStartTime: 'Charge Start Time',
	ChargeEndTime: 'Charge End Time',
	PrivacyConsent: 'Privacy Consent',
	PrivacyInformation: 'Privacy Information',
	PrivacyCompanyName: 'Privacy Company Name',
	PrivacyStartDate: 'Privacy Start Date',
	PrivacyDevice: 'Privacy Device',
	VisitInformation: 'Visit Information',
	VehicleVisitId: 'Vehicle Visit ID',
	CheckInDate: 'Check In Date',
	DealerName: 'Dealer Name',
	ConnectedVehicleSettings: 'Connected Vehicle Settings',
	DeviceName: 'Device Name',
	TeleserviceCapabilities: 'Teleservice Capabilities',
	RemoteTeleserviceCalls: 'Remote Teleservice Calls',
	TeleserviceContract: 'Teleservice Contract',
	TelemetryLastUpdated: 'Telemetry Last Updated',
	ServiceSafetyCampaignSSCIndicator: 'Service Safety Campaign (SSC) Indicator',
	Damaged: 'Damaged',
	VehicleLastUpdated: 'Vehicle Last Updated',
	VehicleCheckCode: 'Vehicle Check Code',
	DealerCategory: 'Dealer Category',
	SupplyChainCategory: 'Supply Chain Category',
	Authorization: 'Authorization',
	LocationData: 'Location Data',
	VehicleConnectivity: 'Vehicle Connectivity',
	VehicleData: 'Vehicle Data',
    Safety: 'Safety',
    ServiceConnect: 'Service Connect',
    Remote: 'Remote',
    DigitalKeyRemote: 'Digital Key Remote',
    DestinationAssist: 'Destination Assist',
    Navigation: 'Navigation',
    VirtualAssist: 'Virtual Assistant',
    IntegratedStreaming: 'Integrated Streaming',
    Wifi: 'Wifi',
    Active: 'ACTIVE',
    NotActive: 'NOT ACTIVE',
	OdometerInformation: 'Odometer Information',
	AvgDistancePerWeek: 'Avg Distance Per Week',
	CheckEngLight: 'Check Engine Light',
	LFTirePressure: 'LF Tire Pressure',
	RFTirePressure: 'RF Tire Pressure',
	LRTirePressure: 'LR Tire Pressure',
	RRTirePressure: 'RR Tire Pressure',
	SpareTirePressure: 'Spare Tire Pressure',
	TireInformation: 'Tire Information',
	General: 'General',
	TireSpeed: 'Tire Speed',
	TirePressureStatus: 'Tire Pressure Status',
	TirePressureByLocation: 'Tire Pressure By Location',
	TirePressureSystem: 'Tire Pressure System',
	FrontTires: 'Front Tires',
	RecommendedFrontPressure: 'Recommended Front Pressure',
	LeftFrontTirePressure: 'Left Front Tire Pressure',
	RightFrontTirePressure: 'Right Front Tire Pressure',
	LeftFrontTireStatus: 'Left Front Tire Status',
	RightFrontTireStatus: 'Right Front Tire Status',
	RearTires: 'Rear Tires',
	RecommendedRearPressure: 'Recommended Rear Pressure',
	DualRearWheels: 'Dual Rear Wheels',
	LeftRearTirePressure: 'Left Rear Tire Pressure',
	RightRearTirePressure: 'Right Rear Tire Pressure',
	LeftRearTireStatus: 'Left Rear Tire Status',
	RightRearTireStatus: 'Right Rear Tire Status',
	InnerLeftRearTirePressure: 'Inner Left Rear Tire Pressure',
	InnerRightRearTirePressure: 'Inner Right Rear Tire Pressure',
	InnerLeftRearTireStatus: 'Inner Left Rear Tire Status',
	InnerRightRearTireStatus: 'Inner Right Rear Tire Status',
	SpareTire: 'Spare Tire',
	SpareTireStatus: 'Spare Tire Status',
    DataFrom: 'Data from',
	DataAsOf: 'Data as of',
	AsOf: 'as of',
    IndicatorOn: 'Indicator On',
	IndicatorOff: 'Indicator Off',
	Outer: 'outer',
	Inner: 'inner',
    DealershipVisits: 'Dealership Visits',
    RecallsAndCampaigns: 'Vehicle Recalls & Campaigns',
    OpenCampaigns: 'Open Campaign(s)',
    RecommendedMaintenance: 'Recommended Maintenance',
    MaintenanceContracts: 'Maintenance Contracts',
    EnrollmentDate: 'Enrollment Date',
	EffectiveDate: 'Effective Date',
	ExpirationDate: 'Expiration Date',
	StartDate: 'Start Date',
	SoldBy: 'Sold By',
	SoldTo: 'Sold To',
	ContractDetails: 'Contract Details',
	ViewContractDetails: 'View Contract Details',
    Infonet: 'Infonet',
	ContractType: 'Contract Type',
	ContractCode: 'Contract Code',
	CVMileage: 'Mileage',
	Deductible: 'Deductible',
	Vendor: 'Vendor',
	Message: 'Message',
    AccountNum: 'Account#',
    Available: 'Available',
    MSRP: 'MSRP',
	Wholesale: 'Wholesale',
	ExpirationMonths: 'Expiration Months',
	CVMiles: 'miles',
	DueDate: 'Due Date',
	Distance: 'Distance',
	OpCode: 'Op Code',
	ID: 'ID',
	Source: 'Source',
	CampaignCode: 'Campaign Code',
	BulletinId: 'Bulletin ID',
	RecallId: 'Recall ID',
	Remedy: 'Remedy',
	StopSale: 'Stop Sale',
	StopSaleCode: 'Stop Sale Code',
	ReservedByDealership: 'Reserved by Dealership',
	PartsRequired: 'Parts Required',
	RepairTime: 'Repair Time',
	SelectAllStatuses: 'Select All Statuses',
    ImportSelectedStatuses: 'Import Selected Statuses to RO',
	SelectAllDTC: 'Select All DTC',
	ImportSelectedDTC: 'Import Selected DTC to RO',
	SelectAllCampaigns: 'Select All Campaigns',
	ImportSelectedCampaigns: 'Import Selected Campaigns to RO',
	SelectAllRecom: 'Select All Rec. Maint.',
	ImportSelectedRecom: 'Import Selected Rec. Maint. to RO',
	On: 'On',
	Off: 'Off',
	NoReportCard: 'No Report Card exists for this Repair Order.  Tire Pressure data could not be imported.',
	ReportCardComplete: 'The Report Card for this Repair Order is already Complete.  Tire Pressure data could not be imported',
    AnErrorOccurred: 'An error occurred: ',
    RefreshRepair: 'Refresh Repair Status',
    RefreshToolTip: 'Click here to refresh the repair status',
    WhatIsThis: `What is this?`,
    AsOf2: `As of`,
    On2: `on`,
    OSDDocDisplayDate: `{0} on {1}`,
    RecommendedServices: 'Recommended Services',
    viewEdit: 'View/Edit',
	AutomatedVehicleQueryRemote: 'Automated Vehicle Query - Remote',
	AutomatedVehicleQueryVehiclePresent: 'Automated Vehicle Query - Vehicle Present',
	ManualVehicleQuery: 'Manual Vehicle Query',
	AllTypes: 'All Types',
	CurrentMonth: 'Current Month',
	LastMonth: 'Last Month',
	Last6Months: 'Last 6 Months',
	LastYear: 'Last Year',
	AllDates: 'All Dates',
    ImportActionSelected: 'Import Action Selected',
    EnteredIssueError: `An entered issue has not been added to the cart.  Would you like to add the issue now?`,
    InvalidFunction: 'Invalid function',
    PleaseRefresh: 'Invalid function, please refresh.',
	RefreshError: 'Refresh error - please try again',
    MaintContractDetails: 'Maintenance Contract Details',
    MaintenanceContract: 'Maintenance Contract',
    MaintContractSubheading1: 'The following maintenance contracts are linked to your vehicle.',
    MaintContractSubheading2: 'Some services may be reduced to $0.00 depending on your coverage.',
    MaintContractSubheading3: 'Please ask your service advisor for more information.',
    MaintContractMessage: 'Some services may be reduced to $0.00 based on your Maintenance Contract coverage.',
    NoMaintContractsFound: 'No maintenance contracts were found for your vehicle',
    ContractIncludesNumItems: 'This Contract includes {0} items:',
    ProvidedBy: 'Provided By',
    CheckMaintContract: 'Check for maintenance contracts for vehicle',
    vehWhichMaintContract: 'Which vehicle would you like to check for maintenance contracts?',
    CheckContracts: 'Check Contracts',
    CheckMC: 'Click the button below to check if there are any maintenance contracts for your vehicle.',
    MaintContractTip: 'Click to check for maintenance contracts for your vehicle',
    MaintContractError: 'We are unable to check your vehicle for maintenance contracts at this time. Please contact the dealership to see if maintenance contracts are linked to your vehicle.',
    MaintContractLinked: 'The following maintenance contracts are linked to your {0} {1}. ',
    PullingMaintContracts: 'We are pulling your maintenance contracts right now. Please wait...',
    NoOustandingMC: 'No maintenance contracts were found for your ',
    VehNoMC: 'No maintenance contracts were found for this vehicle.',
    WhereIsMyVIN: 'Where is my VIN?',
    WhereVinHeader: 'Vehicle Identification Number (VIN)',
    TypicalVINLoc: 'Typical VIN Locations on Your Vehicle',
    OtherVinLoc: 'Other VIN Locations:',
    InsuranceIdCard: 'Insurance identification card',
    VehRegCard: 'Vehicle registration card',
    MaintenanceContractsFound: 'Maintenance Contracts Found',
    NonVinMaintMenuDisclaimer: '**All prices displayed are estimates based on available information. Final prices may differ.**',
    DeptChangeWarning: `Department Change Warning`,
	DeptChangeMessage: `The changes you made could affect the available appointment date and/or time.  Would you like to continue?`,
	MonthsCovered: 'Months Covered',
	ContractCategory: 'Contract Category',
	Form: 'Form#',
	FormMonth: 'Form Month',
	FormYear: 'Form Year',
	ServiceStatus: 'Service Status',
	ServiceTypeNumber: 'Service Type Number',
	ServiceInterval: 'Service Interval',
    Months: 'months',
    KeyReadDate: 'Key Read Date',
	KeyWriteDate: 'Key Write Date',
    AddAnotherAppointment: 'Would you like to add another appointment?',
    RecallDetails: 'Recall Details',
    VehCommunications: 'VEHICLE COMMUNICATIONS',
	CommunicationType: 'Communication Type',
	Code: 'Code',
	Feature: 'Feature',
	Urgency: 'Urgency',
	Confidence: 'Confidence',
	Condition: 'Condition',
    CommTime: 'Time',
    DidNotFindYou: 'Didn\'t Find You',
    ImNewHere: 'I\'m New Here',
    KeepSearching: 'Let\'s Keep Searching!',
    NationwideVehicleSearch: 'We couldn\'t find you using {0}. Please enter your First and Last Name to do a nationwide vehicle search or select skip to add an appointment as a new customer.',
    NationwideVehiclesFound: 'A nationwide vehicle search found the following vehicle(s) using your information. Do you want to add one of these vehicles to your account?',
    RequiredFieldsToSearch: 'Required fields to search are marked with an asterisk "*"',
    FirstNameLengthError: 'First Name cannot be longer than 30 characters',
    LastNameLengthError: 'Last Name cannot be longer than 30 characters',
    VehicleAddErrorSPM: 'We are having trouble adding your vehicle at this time.',
    ValidNameLength: `First Name + Last Name cannot be longer than 35 characters.`,
    ValidEmailLength: `Email cannot be longer than 62 characters.`,
    ValidCity: `City cannot be longer than 20 characters.`,
    ValidStreet: `Address cannot be longer than 30 characters.`,
    TransRemoveWarnMsg: `Services can\'t be removed when {0} is selected.`,
    TransRemoveSelTimeWarnMsg: `Please confirm a date and time before removing services.`,
    GMRewardsDisclaimerServc: `*Services may be eligible to earn My GM Rewards points. Please ask your service advisor for more information.*`,
    EstimatedGMRewards: `Est Available My GM Rewards:`,
    MinCostAfterRewards: `Minimum Est Cost w/ My GM Rewards:`,
    MinEstCostGM: 'Minimum Est Cost:',
    DollarGM: '$',
    GMRewardsDisclaimerSummary: `Services may be eligible to earn My GM Rewards points. Please ask your advisor for more information.`,
    NotEligibleService: 'Not eligible for selected service',
    ClickToAdd: `Click to confirm and add your appointment`,
    //Pickup and Delivery
    PickupLocation: 'Pick Up Location',
    DropOffLocation: 'Drop Off Location',
    SameAsCheckBox: 'Same as pick up location',
    PULSubHeaderMessage: `Let's set up where your vehicle will be picked up and dropped off after service.`,
    PULHeaderNoName: `Where's Your Vehicle?`,
    StreetAddressErrMsg1: 'Please only use numbers, letters, and spaces',
    StreetAddressErrMsg2: 'This field is required, please enter a street address.',
    CityErrMsg: 'Please enter a city.',
    StateErrMsg: 'Please select one of the dropdown options',
    ZIPCodeErrMsg: 'Please enter a valid 5 or 9 digit ZIP Code',
    PostalCodeErrMsg: 'Please enter a valid 6 digit Postal Code in the format A1A 1A1',
    StreetAddress2: 'Street Address 2',
    AdditionalComments: 'Additional Comments...',
    CharactersRemaining: ' characters remaining...',
    ChangeInfoErrMsg: `We are unable to update your information at this time. Please contact the dealership to update your information.`,
    Information: 'Information',
    StatusNotStarted: `Not Started`,
    LetsGetStarted: `Let's Get Started`,
    LetsGo: `Let's Go`,
    MyAccount: `My Account`,
    ContinueAsGuest: 'Continue as Guest',
    ImNew: `I'm new`,
    GuestPrompt: `I'm new around here. I'd like to manually choose my Year/Model of my vehicle to access basic scheduling information.`,
    ViewPastRecalls: `Past Recalls & Campaigns`,
    PastRecalls: `PAST RECALLS & CAMPAIGNS`,
    RecallStatus: `Status`,
    RemedyNotAvailable: `Remedy Not Available`,
    WhatIsRemedyNotAvail: `Remedy Not Available means an incomplete or “open” recall was found for your vehicle, but the manufacturer is not yet ready to provide the needed remedy or fix.`,
    PricingConfirmedUponArrival: `*Pricing will be confirmed upon arrival`,
};
